import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Row} from "react-bootstrap";
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import configInfo from '../config/config.json';
import { translateAPIError } from '../utils/apiUtils';


const UserGroupAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [userGroupAttrs, setUserGroupAttrs] = useState({
    userGroupId: '',
    name: '',
    nameLang2: '',
    nameLang3: '',
    description: ''
  });

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setUserGroupAttrs({ ...userGroupAttrs, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!userGroupAttrs.name || userGroupAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if (userGroupAttrs.name.length > 100) {
      setErrMsg(t("I18N_Name") + " - " + t("I18N_ERR_Max_len") + "100");

    } else if (!userGroupAttrs.nameLang2 || userGroupAttrs.nameLang2.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_2") + ")");
    } else if (userGroupAttrs.nameLang2.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");

    } else if (!userGroupAttrs.nameLang3 || userGroupAttrs.nameLang3.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_3") + ")");
    } else if (userGroupAttrs.nameLang3.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");

    } else if (!userGroupAttrs.description || userGroupAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (userGroupAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "250");

    } else {
      validateNames();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateNames() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("usergroups?nameExist=" + userGroupAttrs.name +
                                                      "&nameLang2Exist="   + userGroupAttrs.nameLang2 +
                                                      "&nameLang3Exist="   + userGroupAttrs.nameLang3);

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {
          // UserGroup code is taken
          setErrMsg(t("I18N_ERR_UserGroupName_taken"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    createNewUserGroup();
  }

  const createNewUserGroup = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(userGroupAttrs));

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.post("usergroups", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_UseGroup")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_UserGroup_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Name")}: *</Col>
              { configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                <Col md={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}: *</Col>
              : null
              }
              { configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                <Col md={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}: *</Col>
              : null
              }
              <Col md={3}>{t("I18N_Description")}: *</Col>
              { !configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                <Col></Col>
              : null
              }
              { !configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                <Col></Col>
              : null
              }
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} name="name" value={userGroupAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              { configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                <Col md={3}>
                  <input className={classes.admin_pages__field_editable} name="nameLang2" value={userGroupAttrs.nameLang2}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              : null
              }
              { configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                <Col md={3}>
                  <input className={classes.admin_pages__field_editable} name="nameLang3" value={userGroupAttrs.nameLang3}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              : null
              }
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={userGroupAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              { !configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                <Col></Col>
              : null
              }
              { !configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                <Col></Col>
              : null
              }
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default UserGroupAdminNewView;
